import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'atr-home',
  standalone: true,
  imports: [RouterLink],
  template: `
    <main>
      <section class="hero" aria-label="ATR Automotive Detailing">
        <img class="hero-image" src="assets/hero-golf-r.jpg" alt="Black 2022 Volkswagen Golf R after detailing" />
        <div class="hero-scrim"></div>
        <div class="hero-content">
          <p class="eyebrow">Bushnell, IL auto detailing</p>
          <h1>Sharp, glossy, cared-for clean.</h1>
          <p class="hero-copy">
            Hand-focused exterior and interior detailing for daily drivers, weekend cars, and everything that deserves to look dialed in again.
          </p>
          <div class="hero-actions" aria-label="Primary actions">
            <a class="button primary" href="tel:+13093355423">Call 309-335-5423</a>
            <a class="button ghost" routerLink="/book">Send details</a>
            <a class="button ghost" routerLink="/results">See results</a>
            <a class="button ghost" routerLink="/services">View services</a>
          </div>
        </div>
      </section>

      <section class="home-teasers section">
        <article>
          <h2>Exterior and interior details</h2>
          <p>Foam hand wash, wheels, glass, interior blowout, vacuuming, steam sanitization, protectant, and surface care.</p>
          <a routerLink="/services">View services</a>
        </article>
        <article>
          <h2>Real cleanup results</h2>
          <p>Before-and-after proof from cup holders, door panels, tar removal, foam washing, and full vehicle refreshes.</p>
          <a routerLink="/results">See results</a>
        </article>
        <article>
          <h2>Mobile details available</h2>
          <p>Mobile appointments can be requested when water and electricity are available at the location. A slight upcharge applies.</p>
          <a routerLink="/book">Ask about a detail</a>
        </article>
      </section>

      <section class="home-process">
        <div>
          <p class="section-kicker">Products</p>
          <h2>Koch Chemie chemistry, Active 2.3 water flow, and Worx DA polishing.</h2>
        </div>
        <p>
          Koch Chemie products are used for washing, interior cleaning, surface care, pads, polishes, and finishing. The Active 2.3 pressure washer moves water safely at 2.3 GPM and 1000 PSI, with Worx DA polishers available for correction work.
        </p>
      </section>

      <section class="home-result">
        <img src="assets/foam-wash-front.jpg" alt="White SUV covered in foam during hand wash" />
        <div>
          <p class="section-kicker">Personalized service</p>
          <h2>Evenings and weekends.</h2>
          <p>Tell me what you drive and what needs attention. I’ll provide pricing and available times before anything is scheduled.</p>
          <a class="button primary" routerLink="/book">Request a quote</a>
        </div>
      </section>
    </main>
  `,
})
export class HomeComponent {}
